import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect, forwardRef } from 'react';
import { bool, func, number, objectOf, oneOfType, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Flex from '../Flex';
import Text from '../Text';
import { ReviewInput } from './select-rating.styles';
const scores = [1, 2, 3, 4, 5];
const scoresMap = {
  1: 'uma',
  2: 'duas',
  3: 'três',
  4: 'quatro',
  5: 'cinco'
};
const SelectRating = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onChange,
    emptyOutline,
    showLabel,
    labelOptions,
    value,
    name
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onChange", "emptyOutline", "showLabel", "labelOptions", "value", "name"]);

  const [rating, setRating] = useState(value);
  const currentIcon = emptyOutline ? 'StarOutline' : 'Star';
  const evaluation = labelOptions[rating] || '';
  useEffect(() => {
    setRating(value);
    return () => setRating(0);
  }, [value]);

  const getColor = score => {
    if (rating >= score || emptyOutline) {
      return 'stars.base';
    }

    return 'stars.disabled';
  };

  return /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    ref: ref,
    "data-testid": "select-rating",
    justifyContent: "start",
    role: "radiogroup",
    onMouseLeave: () => setRating(value)
  }, scores.map(score => /*#__PURE__*/React.createElement(React.Fragment, {
    key: score
  }, /*#__PURE__*/React.createElement(ReviewInput, {
    type: "radio",
    name: name,
    value: score,
    id: `${name}${score}`,
    onChange: () => onChange({
      target: {
        value: score
      }
    })
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: `${name}${score}`
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    name: rating >= score ? 'Star' : currentIcon,
    cursor: "pointer",
    color: getColor(score),
    onMouseOver: () => setRating(score),
    "aria-label": `${scoresMap[score]} ${score === 1 ? 'estrela' : 'estrelas'}`,
    onClick: () => onChange({
      target: {
        value: score
      }
    })
  }, props)))))), showLabel && /*#__PURE__*/React.createElement(Text, {
    fontSize: [1, 2],
    minWidth: 80,
    textAlign: "center",
    fontWeight: "medium"
  }, evaluation));
});
SelectRating.defaultProps = {
  emptyOutline: false,
  showLabel: false,
  value: '',
  name: 'rating',
  labelOptions: {
    1: 'Péssimo',
    2: 'Ruim',
    3: 'Regular',
    4: 'Bom',
    5: 'Excelente'
  }
};
process.env.NODE_ENV !== "production" ? SelectRating.propTypes = {
  emptyOutline: bool,
  onChange: func.isRequired,
  value: oneOfType([string, number]),
  showLabel: bool,
  labelOptions: objectOf(string),
  name: string
} : void 0;
SelectRating.displayName = 'SelectRating';
export default SelectRating;